import {FaFacebook, FaInstagram, FaLinkedin, FaYoutube} from "react-icons/fa";
import {NavLink} from "react-router-dom";

export default function HeaderTop() {
    return (
        <header className="header-top" data-aos="fade-down">
            <div className="header-top-left">
                <ul>
                    <li><a href="#" target={'_blank'}><FaFacebook/> </a></li>
                    <li><a href="#" target={'_blank'}><FaYoutube/> </a></li>
                    <li><a href="#" target={'_blank'}><FaInstagram/> </a></li>
                    <li><a href="#" target={'_blank'}><FaLinkedin/> </a></li>
                </ul>
            </div>
            <div className="header-top-right">
                <ul>
                    <li><a href="#" target={'_blank'}>Get Help</a></li>
                    {
                        localStorage.getItem("UserId") ?
                            <li><NavLink to={'/user/dashboard'}>Dashboard</NavLink></li> :
                            <li><NavLink to={'/auth/login'}>Login</NavLink></li>
                    }

                </ul>
            </div>
        </header>
    )
}
